
import React from 'react';
import { ScrollArea } from "@/components/ui/scroll-area";
import { Loader2, DollarSign, Users, Globe, Building, Scale, Server, Shield } from "lucide-react";

interface LocationConsiderations {
  economic: string;
  demographic: string;
  cultural: string;
  political: string;
  market: string;
  technological: string;
  barriers: string;
}

interface LocationConsiderationsProps {
  considerations: LocationConsiderations;
  aiEngine: string;
  isAnalyzing: boolean;
  isLoadingPlace: boolean;
}

export const LocationConsiderations: React.FC<LocationConsiderationsProps> = ({
  considerations,
  aiEngine,
  isAnalyzing,
  isLoadingPlace
}) => {
  return (
    <div className="bg-secondary/50 backdrop-blur-lg border-2 border-primary rounded-lg shadow-lg shadow-purple-500/10 w-[50%] bg-secondary/50 p-2 py-[24px] my-[8px] h-[560px]">
      <div className="flex items-center gap-2 mb-2">
        <h2 className="text-xl font-semibold text-white">
          Considerations ({aiEngine === 'openai' ? 'OpenAI' : 'DeepSeek'})
        </h2>
        {(isAnalyzing || isLoadingPlace) && <Loader2 className="w-4 h-4 animate-spin text-primary" />}
      </div>
      
      <ScrollArea className="h-[486px] pr-2">
        <div className="flex flex-col gap-2">
          <div className="flex items-center gap-2 bg-secondary/30 p-2 rounded-lg">
            <DollarSign className="w-6 h-6 text-primary shrink-0" />
            <div>
              <p className="text-xs text-primary-light">Economic Environment</p>
              <p className="text-xs text-white">{considerations.economic}</p>
            </div>
          </div>

          <div className="flex items-center gap-2 bg-secondary/30 p-2 rounded-lg">
            <Users className="w-6 h-6 text-primary shrink-0" />
            <div>
              <p className="text-xs text-primary-light">Demographics</p>
              <p className="text-xs text-white">{considerations.demographic}</p>
            </div>
          </div>

          <div className="flex items-center gap-2 bg-secondary/30 p-2 rounded-lg">
            <Globe className="w-6 h-6 text-primary shrink-0" />
            <div>
              <p className="text-xs text-primary-light">Cultural & Social</p>
              <p className="text-xs text-white">{considerations.cultural}</p>
            </div>
          </div>

          <div className="flex items-center gap-2 bg-secondary/30 p-2 rounded-lg">
            <Building className="w-6 h-6 text-primary shrink-0" />
            <div>
              <p className="text-xs text-primary-light">Political & Legal</p>
              <p className="text-xs text-white">{considerations.political}</p>
            </div>
          </div>

          <div className="flex items-center gap-2 bg-secondary/30 p-2 rounded-lg">
            <Scale className="w-6 h-6 text-primary shrink-0" />
            <div>
              <p className="text-xs text-primary-light">Market Dynamics</p>
              <p className="text-xs text-white">{considerations.market}</p>
            </div>
          </div>

          <div className="flex items-center gap-2 bg-secondary/30 p-2 rounded-lg">
            <Server className="w-6 h-6 text-primary shrink-0" />
            <div>
              <p className="text-xs text-primary-light">Technology</p>
              <p className="text-xs text-white">{considerations.technological}</p>
            </div>
          </div>

          <div className="flex items-center gap-2 bg-secondary/30 p-2 rounded-lg">
            <Shield className="w-6 h-6 text-primary shrink-0" />
            <div>
              <p className="text-xs text-primary-light">Barriers to Entry</p>
              <p className="text-xs text-white">{considerations.barriers}</p>
            </div>
          </div>
        </div>
      </ScrollArea>
    </div>
  );
};
